export const STAFF_REGULATORS_PATH_PREFIX = "/staff-management-new/regulators";

export const STAFF_REGULATORS_LIST_ROUTE = STAFF_REGULATORS_PATH_PREFIX;

export const STAFF_REGULATORS_NEW_ROUTE = `${STAFF_REGULATORS_PATH_PREFIX}/new`;

export const STAFF_REGULATORS_PROFILE_ROUTE = `${STAFF_REGULATORS_PATH_PREFIX}/:regulatorId`;

export const buildStaffRegulatorProfilePath = (
  regulatorId?: string | null,
): string => {
  if (regulatorId == null) return STAFF_REGULATORS_LIST_ROUTE;
  const id = String(regulatorId).trim();
  if (!id) return STAFF_REGULATORS_LIST_ROUTE;
  return `${STAFF_REGULATORS_PATH_PREFIX}/${encodeURIComponent(id)}`;
};
